// 2020-02-28T06:38:00
export const MIN_ISO_DATE_LENGTH = 19;

const trimISODate = (dateStr: string): string =>
  decodeURIComponent(dateStr).substring(0, MIN_ISO_DATE_LENGTH);

export default trimISODate;
